import { FileButton, Group } from '@mantine/core'
import React from 'react'
import AppButton from '../common/AppButton'
import { themeCfg } from '../../theme/theme'
import swalAlert from '../../utils/helpers/swalAlert'

interface CustomProps
  extends Omit<React.ComponentPropsWithoutRef<typeof FileButton>, 'children'> {
  invisible?: boolean
  disabled?: boolean
  w?: string | number
  ref?: React.Ref<any>
  name?: string
  label?: string
  labelh?: string
  placeholder?: string
  entity?: string
  accept?: string
  onChange: (file: File | null) => void
}

const AppFileButton = ({
  invisible = false,
  disabled = false,
  w = '100%',
  ref,
  name,
  label,
  entity,
  accept = 'application/pdf,image/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  onChange,
  multiple = false,
  ...otherProps
}: CustomProps) => {
  const handleVerifyAcceptedFiles = (file: File | File[] | null): boolean => {
    if (!file) return false

    const acceptedTypesArray = accept.split(',').map((t) => t.trim())

    if (multiple && Array.isArray(file)) {
      return file.every((f) => acceptedTypesArray.includes(f.type))
    }

    const singleFile = Array.isArray(file) ? file[0] : file
    return acceptedTypesArray.includes(singleFile.type)
  }

  if (invisible)
    return themeCfg?.debug ? <Group fz="80%">h.button</Group> : null
  return (
    <FileButton
      {...otherProps}
      onChange={(_value) => {
        if (handleVerifyAcceptedFiles(_value)) {
          onChange({ [name]: [_value] })
        } else {
          swalAlert.error('El archivo no es válido')
        }
      }}
      accept={accept}
      multiple={multiple}
    >
      {(props) => (
        <AppButton
          {...props}
          preset="upload"
          disabled={disabled}
          data-invisible={invisible}
        />
      )}
    </FileButton>
  )
}

export default AppFileButton
